import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const ChassisNumber = ({ chassisNumber }: SpecProps<"chassis_number">) => {
  const { i18n } = useLingui();

  if (chassisNumber == null || chassisNumber === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.chassis_number",
    message: "Chassis number",
    comment: "Field for 'chassis number' in ad specification",
  });
  return <FieldValuePair field={field} value={chassisNumber} />;
};
